export const Locale = [
  { code: 'en_IE', name: 'English - Ireland' },
  { code: 'en_GB', name: 'English - United Kingdom' },
  { code: 'it_IT', name: 'Italian - Italy' },
  { code: 'es_ES', name: 'Spanish - Spain' },
  { code: 'fr_FR', name: 'French - France' },
  { code: 'de_DE', name: 'German - Germany' },
  { code: 'pl_PL', name: 'Polish - Poland' }
];
